import CmsBlock from 'Component/CmsBlock';
import { RENDER_NEWSLETTER } from 'Component/Footer/Footer.config';

import ApplePay from '../../assets/images/ApplePay.png';
import Blik from '../../assets/images/Blik.png';
import DPD from '../../assets/images/dpd.png';
import Gpay from '../../assets/images/Gpay.png';
import Inpost from '../../assets/images/inpost.png';
import MasterCard from '../../assets/images/MasterCard.png';
import P24 from '../../assets/images/P24.png';
import P25now from '../../assets/images/P24NOW.png';
import PayU from '../../assets/images/PayU.png';
import Visa from '../../assets/images/visa.png';

export * from 'AdvoxComponent/Footer/Footer.config.js';

/** @namespace Pwa/Component/Footer/Config/renderNewsletterText */
export const renderNewsletterText = () => <CmsBlock identifier="newsletter_subscription_header_text" />;

/** @namespace Pwa/Component/Footer/Config/renderNewsletterHeader */
export const renderNewsletterHeader = () => <CmsBlock identifier="newsletter_subscription_header" />;

export const NEWSLETTER_COLUMN = {
    title: renderNewsletterHeader(),
    columnActiveKey: 'newsletterActive',
    subtitle: renderNewsletterText(),
    items: [
        {
            render: RENDER_NEWSLETTER,
        },
    ],
};

export const ShippingOptions = [
    { label: 'inpost', icon: Inpost },
    { label: 'dpd', icon: DPD },
];
export const PaymentOptions = [
    { label: 'blik', icon: Blik },
    { label: 'p25now', icon: P25now },
    { label: 'p24', icon: P24 },
    { label: 'payU', icon: PayU },
    { label: 'gpay', icon: Gpay },
    { label: 'applePay', icon: ApplePay },
    { label: 'visa', icon: Visa },
    { label: 'masterCard', icon: MasterCard },
];

export const FACEBOOK = 'https://pl-pl.facebook.com/pieknowdomu/';
export const PINTEREST = 'https://www.instagram.com/pieknowdomupl/';
export const INSTAGRAM = 'https://pl.pinterest.com/pieknowdomupl/';

export const FOOTER_SOCIAL_BLOCK_ID = 'footer_social';
export const FOOTER_ADDRESS_BLOCK_ID = 'footer_address';
